export enum DIRECTORY_TAB {
  AGENTS = 'Agents',
  PERSONAL = 'Personal',
  ORGANISATION = 'Organisation',
}

export const DIRECTORY_TABS = [DIRECTORY_TAB.AGENTS, DIRECTORY_TAB.PERSONAL, DIRECTORY_TAB.ORGANISATION];
